import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Grid,
  Avatar,
  Typography,
  Button,
} from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';

const ProfileHeader = (props) => {
  const classes = useStyles();
  const { profileUserData} = props

  return (
    <div className={classes.container}>
      {/* top container */}
      <div className={classes.topContainer}>
        <div className={classes.avatar}>
          <Avatar className={classes.profilePic} alt={profileUserData.nickname} src={profileUserData.profileImg} />
        </div>
        <div>
          <Typography style={{ marginTop: '4px', marginBottom: 8, fontWeight:'bold' }} variant='h2'>
            {profileUserData.nickname}
          </Typography>
          <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
            <Rating
              style={{ color: '#F2C94C', marginRight: 8}}
              name='simple-controlled'
              value={profileUserData.averagerating}
              readOnly
            />
            <Typography variant={'subtitle1'} style={{ color: '#828282' }}>{` (${profileUserData.reviewcount})`}</Typography>
          </div>
        </div>
      </div>
      {/* bottom container*/}
      <div className={classes.subContainer}>
        <div className={classes.counts}>
          <Button className={classes.countsItem}>
            <div>
              <Typography variant='body1' style={{fontWeight: 'bold', color: '#333333'}}>{profileUserData.followerscount}</Typography>
              <Typography variant='body2' style={{color: '#333333'}}>Followers</Typography>
            </div>
          </Button>
          <Button className={classes.countsItem}>
            <div>
              <Typography variant='body1' style={{fontWeight: 'bold', color: '#333333'}}>{profileUserData.followingcount}</Typography>
              <Typography variant='body2' style={{color: '#333333'}}>Following</Typography>
            </div>
          </Button>
        </div>
      </div>
      <Grid item style={{ marginTop: '16px', width: '100%' }}>
        <Typography variant='body1'>{profileUserData.about}</Typography>
      </Grid>
    </div>
  );
};

export default ProfileHeader;

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.down('sm')]: {
      margin: '16px 16px 0px',
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: '40px',
    },
  },
  subContainer: {
    width: '100%',
    marginTop: 18,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  topContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  avatar: {
    [theme.breakpoints.down('md')]: {
      marginRight: 49,
      marginLeft: 31,
    },
    [theme.breakpoints.up('md')]: {
      marginRight: 77,
      marginLeft: 53,
    },
    [theme.breakpoints.down('sm')]: {
      marginRight: 16,
      marginLeft: 0,
    },
  },
  profilePic: {
    [theme.breakpoints.down('sm')]: {
      width: '96px',
      height: '96px',
    },
    [theme.breakpoints.up('sm')]: {
      width: '109px',
      height: '109px',
    },
  },
  userInfo: {
    marginTop: 8,
  },
  button: {
    height: 32,
    [theme.breakpoints.down('md')]: {
      width: 171,
    },
    [theme.breakpoints.up('md')]: {
      width: 223,
    },
    [theme.breakpoints.down('sm')]: {
      width: 104,
      marginRight: 30,
    },
    textTransform: 'none',
  },
  counts: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      columnGap: 16,
    },
    [theme.breakpoints.up('sm')]: {
      columnGap: 40,
    },

  },
  countsItem: {
    textTransform: 'none',
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
    color: '#333333',
  }
}));